import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import MaterialIcon from './MaterialIcon';
import { usePopper } from 'react-popper';
import useOutsideClick from 'HOOKS/useOutsideClick';


const HelperTooltip = (props) => {

	const [expanded, setExpanded] = useState(false);
	const [clearRef, setClearRef] = useState(null);
	const [referenceElement, setReferenceElement] = useState(null);
	const [popperElement, setPopperElement] = useState(null);
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
	placement: 'top',
	modifiers: [],
	});

	useOutsideClick(popperElement, [popperElement], (event) => {
	    if (referenceElement.contains(event.target)) return;
	    setExpanded(false);
	  });
	
	return (
		<>
			<a 
			className={clsx('lttt-helper')}
			role="button"
			onMouseOver={ (e) => {
				setExpanded(true);
			} }
			onMouseLeave={ (e) => {
				e.persist();
				setExpanded(false);
			} }
			ref={ setReferenceElement }
			>
				<MaterialIcon icon="help" size="20" />
			</a>
		
	        <div
	          ref={ setPopperElement }
	          style={{
	            ...styles.popper,
	            zIndex: 4,
	            minWidth: '250px',
	          }}
	          { ...attributes.popper }
	          className={clsx('lttt_tooltip', expanded && 'in')}
	        >	
	        	<div className={clsx('lttt_tooltip-inner')}>
	        	<p>{`Preferabli has developed the most comprehensive database of taste characteristics in the world for wine, beers and spirits – so you can discover what you'll like based on your taste preferences!`}</p>
	        	</div>
	        </div>
		</>
	);
};

HelperTooltip.propTypes = {};
HelperTooltip.defaultProps = {};

export default HelperTooltip;
